/**
 * Dynamic grid styles for comparison table
 * 
 * Applies grid-template-columns to .e-div--content based on count of .e-div--top elements
 * Applies grid-row span to .e-div--top based on count of > div elements inside it
 */
( function() {
  'use strict';

  const applyGridStyles = () => {
    const comparisonTables = document.querySelectorAll( '.e-stn--comparison-table' );

    comparisonTables.forEach( ( table ) => {
      const contentDiv = table.querySelector( '.e-div--content' );
      if ( !contentDiv ) return;

      // Count .e-div--top elements
      const topElements = table.querySelectorAll( '.e-div--top' );
      const topCount = topElements.length;

      if ( topCount > 0 ) {
        // Apply grid-template-columns based on count of .e-div--top elements
        contentDiv.style.gridTemplateColumns = `repeat(${topCount}, 1fr)`;
      }

      // Process each .e-div--top element
      topElements.forEach( ( topElement ) => {
        // Count direct child div elements
        const childDivs = topElement.querySelectorAll( ':scope > div' );
        const childCount = childDivs.length;

        if ( childCount > 0 ) {
          // Apply grid-row span based on count of > div elements
          topElement.style.gridRow = `span ${childCount}`;
        }
      } );
    } );
  };

  const init = () => {
    applyGridStyles();
  };

  if ( document.readyState === 'loading' ) {
    document.addEventListener( 'DOMContentLoaded', init );
  } else {
    init();
  }
}() );

